import { Text } from '@chakra-ui/react';
import { ESTIMATED_WEIGHT_SCALE_ICON_SRC } from '@diamond/sol-buyer/utils';

import { InfoHighlightPill } from '../../common/info-highlight-pill';

export { ESTIMATED_WEIGHT_SCALE_ICON_SRC } from '@diamond/sol-buyer/utils';

export const ESTIMATED_WEIGHT_PRICE_COPY =
  'Total harga menyesuaikan timbangan.';

export const ESTIMATED_WEIGHT_FINAL_COPY =
  'Berat final setelah barang ditimbang.';

type EstimatedWeightPriceBannerProps = {
  size?: 'md' | 'sm';
};

/**
 * Yellow gradient pill from Figma Timbangan (19661:187966 / 21449:207636).
 * Built on reusable `InfoHighlightPill`.
 */
export function EstimatedWeightPriceBanner({
  size = 'md',
}: EstimatedWeightPriceBannerProps) {
  return (
    <InfoHighlightPill
      iconSrc={ESTIMATED_WEIGHT_SCALE_ICON_SRC}
      size={size === 'md' ? 'lg' : 'md'}
      variant="gradient"
      data-testid="estimated-weight-price-banner"
    >
      {ESTIMATED_WEIGHT_PRICE_COPY}
    </InfoHighlightPill>
  );
}

export function EstimatedWeightFinalNote() {
  return (
    <Text fontSize="12px" color="#373F41" lineHeight="short" maxW="138px">
      {ESTIMATED_WEIGHT_FINAL_COPY}
    </Text>
  );
}
